// extracted by mini-css-extract-plugin
module.exports = {"containterInicial":"Inicial_containterInicial__2YWa3","logo":"Inicial_logo__1A__9","logoBtn":"Inicial_logoBtn__kATgY","inicio":"Inicial_inicio__1sbcZ"};